export default {
    book: 'Prenota {product}',
    age_limit: 'Solo per maggiori di {age} anni',
    change_plan: 'Cambia piano',
    upgrade_product: 'Aggiorna prodotto',
    upgrade: 'Aggiorna',
    cancel_upgrade: 'Annulla aggiornamento',
    choose_product: 'Scegli {product}',
    days: '{count} giorno | {count} giorni',
    login_register: 'Accedi/Registrati',
    current: 'Attuale',
    keyless_benefits: {
        label: 'Direttamente all’auto {0}',
        highlight: 'servizio di noleggio™',
        list: {
            cant_lose_the_key: 'Assicurazione completa',
            zero_excess: 'Zero franchigia',
            phone_as_a_key: 'Telefono come chiave',
            straight_to_car: 'Nessuna attesa',
            no_queues: 'Nessuna coda',
            online_id_check: 'Verifica ID online',
            self_checkout: 'Self Check-out',
        },
    },
};
